const convertHtmlToPlain = (html: any) => {
  return html.replace(/<[^>]+>/g, "");
};
export default convertHtmlToPlain;
